export default "__VITE_ASSET__DWcOuTYS__"